import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";

import Modal from "../../layouts/Modal";
import useWilmaUsers from "../../data/useWilmaUsers";
import { TextInput } from "../shared/Inputs/TextInput";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";

type FormValues = {
  password: string;
  confirmPassword: string;
};

export default function StaffPasswordModal({ open, setOpen, staff }: { open: boolean; setOpen: React.Dispatch<React.SetStateAction<boolean>>; staff: { id: string } | undefined }) {
  const { updatePassword } = useWilmaUsers();
  const [error, setError] = useState<string | null>(null);
  const { register, handleSubmit, reset, formState: { errors } } = useForm<FormValues>();

  const { saveHandlers } = useDefaultCRUDHandlers("Staff");

  useEffect(() => {
    if (staff) {
      reset({ password: "", confirmPassword: "" });
    }
  }, [staff, reset]);

  const onSubmit = async (data: FormValues) => {
    if (data.password !== data.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      await updatePassword.mutateAsync({ userId: staff!.id, password: data.password });
      setOpen(false);
      reset();
    } catch (err) {
      setError("Failed to update password");
    }
  };

  return (
    <Modal open={open} setOpen={setOpen} width="max-w-2xl">
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <TextInput
          label="New Password"
          type="password"
          registerName={"password"}
          register={register}
        />
        <TextInput
          label="Confirm Password"
          type="password"
          registerName={"confirmPassword"}
          register={register}
        />
        {error && <p className="text-red-500">{error}</p>}
        <ButtonInput isSubmit label="Update Password" onClick={undefined} classes={undefined}  />
      </form>
    </Modal>
  );
}